import { render } from "./MainVouchers.vue?vue&type=template&id=19f4a90e&scoped=true"
import script from "./MainVouchers.vue?vue&type=script&lang=js"
export * from "./MainVouchers.vue?vue&type=script&lang=js"

import "./MainVouchers.vue?vue&type=style&index=0&id=19f4a90e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f4a90e"]])

export default __exports__